import Button from '@atlaskit/button/standard-button';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import React from 'react';
export const DiscardChangesModal = _ref => {
  let {
    openModal,
    closeModal,
    onDiscard
  } = _ref;
  const handleDiscardChanges = () => {
    closeModal();
    onDiscard();
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ModalTransition, null, openModal && /*#__PURE__*/React.createElement(Modal, {
    onClose: closeModal
  }, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(ModalTitle, {
    appearance: "warning"
  }, "Are you sure you want to discard changes?")), /*#__PURE__*/React.createElement(ModalBody, null, "If you have made any changes to the responses, you may lose them. The page will revert back to the version which is currently live on the listing page."), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    appearance: "subtle",
    onClick: closeModal
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    appearance: "warning",
    onClick: handleDiscardChanges,
    autoFocus: true
  }, "Discard changes")))));
};
export default DiscardChangesModal;